<template>
	<ImageCollageShell
		:data="data"
		:editable="editable"
		:active="active"
		:h5="h5"
		@select="$emit('select')"
	/>
</template>

<script>
	import ImageCollageShell from '../shared/ImageCollageShell.vue';
	import { imageBlockEmits, imageBlockProps } from '../shared/imageBlockProps.js';

	export default {
		name: 'GBlockImageCollage',
		components: { ImageCollageShell },
		props: imageBlockProps,
		emits: imageBlockEmits,
	};
</script>
